import types from './types';

const toggle = state => ({
  type: types.TOGGLE_SDS_COPY_MODAL,
  state: state || false
});

export default {
  toggle
};

export const actions = {
  toggle
};
